/**
 * Client de la passerelle DOIT — FAÇADE.
 *
 * Toutes les requêtes passent par `request` (dans `./http`), qui normalise les erreurs :
 * le reste de l'application ne manipule jamais de `Response` brute et ne peut donc pas
 * oublier de traiter un échec. Une erreur porte son code HTTP et son message, jamais le
 * corps brut d'une réponse susceptible de contenir des données sensibles.
 *
 * Ce fichier est une FAÇADE DE RÉ-EXPORT (WO-V3-02 / US-019) : le contenu réel a été
 * déplacé, sans réécriture, dans :
 *  - `./http.ts` (cœur HTTP : BASE, ApiError, request, requestAvecReponse, httpMessage,
 *    Page, requestPage) ;
 *  - `./types/*.ts` (types du domaine, groupés par domaine métier) ;
 *  - `./*Api.ts` (méthodes de l'objet `api`, groupées par domaine métier).
 *
 * Import applicatif inchangé : `import { api, ApiError, ... } from '../api/client'`
 * continue de fonctionner à l'identique (surface figée par
 * `client.surface.characterization.test.ts` et `client.surface.types.contract.ts`).
 */

export { ApiError, requestPage } from './http'
export type { Page } from './http'

export * from './types/workspaceTemplate'
export * from './types/deployment'
export * from './types/testManagement'
export * from './types/aiAdmin'
export * from './types/approvals'
export * from './types/collaboration'
export * from './types/backlog'
export * from './types/scmAudit'
export * from './types/hitl'
export * from './types/quota'
export * from './types/defects'
export * from './types/organisation'
export * from './types/decisions'
export * from './types/version'
export * from './types/missions'
export * from './types/releases'
export * from './types/previews'
export * from './types/profile'
export * from './types/design'

import { workspaceLifecycleAndTestManagementApi } from './workspaceLifecycleAndTestManagementApi'
import { programsTemplatesAndArtifactsApi } from './programsTemplatesAndArtifactsApi'
import { comparisonsAndPipelinesApi } from './comparisonsAndPipelinesApi'
import { adminModelsQuotasAndCollabApi } from './adminModelsQuotasAndCollabApi'
import { backlogAgileAndCollaborationApi } from './backlogAgileAndCollaborationApi'
import { scmAndAttachmentsApi } from './scmAndAttachmentsApi'
import { hitlCockpitApi } from './hitlCockpitApi'
import { quotaApi } from './quotaApi'
import { defectsApi } from './defectsApi'
import { organisationReferentialApi } from './organisationReferentialApi'
import { decisionsApi } from './decisionsApi'
import { versionApi } from './versionApi'
import { missionsApi } from './missionsApi'
import { releasesApi } from './releasesApi'
import { previewsApi } from './previewsApi'
import { profilePreferencesApi } from './profilePreferencesApi'
import { designApi } from './designApi'

export const api = {
  ...workspaceLifecycleAndTestManagementApi,
  ...programsTemplatesAndArtifactsApi,
  ...comparisonsAndPipelinesApi,
  ...adminModelsQuotasAndCollabApi,
  ...backlogAgileAndCollaborationApi,
  ...scmAndAttachmentsApi,
  ...hitlCockpitApi,
  ...quotaApi,
  ...defectsApi,
  ...organisationReferentialApi,
  ...decisionsApi,
  ...versionApi,
  ...missionsApi,
  ...releasesApi,
  ...previewsApi,
  ...profilePreferencesApi,
  ...designApi,
}
